import ENV from 'config/environment'
import { ProbateCase } from 'lib/models/probate-case'

export const getNavLinks = (probateCase: ProbateCase) => {
  const { id } = probateCase
  const showEstateQuestionnaire = ENV.FF_PROBATE_ESTATE_QUESTIONNAIRE_ENABLED
  const navLinks = [
    { label: 'Summary', url: `/probate/cases/${id}` },
    { label: 'Tasks', url: `/probate/cases/${id}/tasks` },
    { label: 'Documents', url: `/probate/cases/${id}/documents` },
    { label: 'Quote', url: `/probate/cases/${id}/quote` },
    ...(showEstateQuestionnaire
      ? [{ label: 'Estate', url: `/probate/cases/${id}/estate` }]
      : []),
    { label: 'History', url: `/probate/cases/${id}/history` },
  ]

  return navLinks
}

export const getProbateEstateId = (probateCase?: ProbateCase) =>
  probateCase?.attributes.estate?.id
